module.exports = __webpack_public_path__ + "img/yt.226d5728.svg";